jQuery(function () {
	disableCalendarSwitch();
});


function disableCalendarSwitch() {
	if (jQuery('#meeting-params-calendar-id').val() != '') {
		jQuery("#meeting-params-calendar-switch").parent().addClass("js-metabox-disable");
	}
}